import { ETypOsoby } from 'enums/amlz/typOsoby';

const typOsobySelect = [
    {
        value: ETypOsoby.FYZICKAOSOBA,
        labelcz: 'FYZICKA_OSOBA'
    },
    {
        value: ETypOsoby.PRAVNICKAOSOBA,
        labelcz: 'PRAVNICKA_OSOBA'
    }
];

export default typOsobySelect;
